const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3bfbcdff413e9fbb377f3ab49f95f79bc410e450"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["moodlight-app@moodlight"]={id:"3bfbcdff413e9fbb377f3ab49f95f79bc410e450"};
      